import "./UpdateUsersById.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import FormInput from "../../components/FormInput/FormInput";
import newRequest from "../../context/newRequest";
import {sleep} from "../../helper/helper";

const UpdateUsersById = ({ title }) => {
    const [values, setValues] = useState({
        username: "",
        email: "",
        company_name: "",
        password: "",
        confirmPassword: "",
    });
    const [info, setInfo] = useState({})
    const [usersUpdate, setUsersUpdate] = useState({});
  const { userId } = useParams();
  const user = localStorage.getItem("user");
    const [regionId, setRegionId] = useState(undefined);
    const { data, loading, error } = useFetch(`/users/${userId}`);
  const [sending, setSending] = useState("");
  const  navigate= useNavigate();
  useEffect(() => {
    setInfo(data);
  }, [data]);




  console.info(values)



  const handleChange = (e) => {
      setValues({ ...values, [e.target.name]: e.target.value });
  };
    const handleSelectRegionID = (e) => {
        const value = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        );
        setRegionId(value[0]);
    };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
        setSending("On Submit")
      const newUsersUpdate = {
        ...values,
          region_id: regionId
      };
        await sleep(1000)
        setSending("Mengirim data ...")

     const res= await newRequest.put(`/users/${userId}`, newUsersUpdate, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      });
     setSending("Sending...")
      if (res.status == 200) {
          await sleep(1000)

          navigate(`/users/${userId}`);
      }
      console.log(res.status)
    } catch (err) {
        await sleep(2000)
        setSending(err.response.data.errors)
      console.log(err);
    }
  };

  console.log(info)
    const inputs = [
        {
            id: "username",
            name: "username",
            type: "text",
            placeholder: "username",
            errorMessage:
                "Username should be 3-16 characters and shouldn't include any special character!",
            label: "Username",
            pattern: "^[A-Za-z0-9]{3,16}$",
            required: false,
        },
        {
            id: "email",
            name: "email",
            type: "email",
            placeholder: "email",
            errorMessage: "It should be a valid email address!",
            label: "Email",
            required: false,
        },
        {
            id: "company_name",
            name: "CompanyName",
            type: "text",
            placeholder: "company name",
            errorMessage:
                "Company should be 3-16 characters and shouldn't include any special character!",
            label: "Company Name",
            pattern: "^[A-Za-z0-9 ]{3,16}$",
            required: false,
        },
        {
            id: "password",
            name: "password",
            type: "password",
            placeholder: "Password",
            errorMessage:
                "Password should be 8-20 characters and include at least 1 uppercase letter, 2 numbers, and any other characters!",
            label: "Password",
            pattern: `^(?=.*[A-Z])(?=(?:.*[0-9]){2})[a-zA-Z0-9!@#$%^&*]{8,20}$`,
            required: false,
        },
        {
            id: "confirm_password",
            name: "confirmPassword",
            type: "password",
            placeholder: "Confirm Password",
            errorMessage: "Passwords don't match!",
            label: "Confirm Password",
            pattern: values.password,
            required: false,
        },
    ];

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
          <div className="bottom">
              <div className="right">
                  <div className="detailItem">
                      <div>
                          <h1>{userId}</h1>
                      </div>
                  </div>
                  <form onSubmit={handleClick}>
                      {inputs.map((input) => (
                          <FormInput
                              key={input.id}
                              {...input}
                              value={values[input.name]}
                              onChange={handleChange}
                          />
                      ))}
                      <select id="region_id" onChange={handleSelectRegionID}>
                          <option >Pilih Region Id</option>
                          <option value="Jakarta">Jakarta</option>
                          <option value="JABODETABEK">JABODETABEK</option>
                          <option value="Jawa Timur">Jawa Timur</option>
                          <option value="Lampung">Lampung</option>
                          <option value="Bali">Bali</option>
                          <option value="Yogyakarta">Yogyakarta</option>

                      </select>
                      <button>Submit</button>
                  </form>
              </div>
              {sending && <p className="error">{sending}</p>}


          </div>
      </div>
    </div>
  );
};

export default UpdateUsersById;
